import { isAbsolute, normalize } from "path";
import isFQDN from "validator/lib/isFQDN";
import { EntrypointUrlMatcherNotValidError } from "../common/errors";
/*
 *  A valid entrypoint urlMatcher has the shape domain + path, where domain is a
 *  fully-qualified domain name WITHOUT the ending dot, and path is an absolute
 *  and normalized path ending with a / (slash).
 *
 *  Example of valid urlMatchers:
 *  - domain.com/
 *  - domain.com/path/
 *  - subdomain.domain.com/path/subpath/
 *
 *  Example of invalid urlMatchers:
 *  - http://domain.com/
 *  - domain.com./
 *  - domain.com
 *  - domain.com/path
 */
export function isEntrypointUrlMatcherValid(urlMatcher) {
    const indexOfFirstSlash = urlMatcher.indexOf("/");
    // Must contain at least a / to be valid
    if (indexOfFirstSlash === -1) {
        return false;
    }
    const domain = urlMatcher.slice(0, indexOfFirstSlash);
    const path = urlMatcher.slice(indexOfFirstSlash);
    return (isFQDN(domain, { allow_trailing_dot: false }) &&
        isAbsolute(path) &&
        normalize(path) === path &&
        /\/$/.test(path));
}
export function validateEntrypointUrlMatcher(urlMatcher) {
    if (!isEntrypointUrlMatcherValid(urlMatcher)) {
        throw new EntrypointUrlMatcherNotValidError(urlMatcher);
    }
}
//# sourceMappingURL=Entrypoint.js.map